import { render, staticRenderFns } from "./TinTucList.vue?vue&type=template&id=2b24359c"
import script from "./TinTucList.vue?vue&type=script&lang=js"
export * from "./TinTucList.vue?vue&type=script&lang=js"
import style0 from "./TinTucList.vue?vue&type=style&index=0&id=2b24359c&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports